import axios from "axios"
import { GetWeatherAction } from "./weather"

// DEFAULT VALUE

const defaultValue = {
    latitude: '',
    longitude: '',
    state: '',
    city: '',
    country: ''

}

// ACTION TYPES

const GETGEOLOCATION = 'GETGEOLOCATION'
const GETCITYLOCATION = 'GETCITYLOCATION'


// REDUCER

export default function LocationReducer(state = defaultValue, { type, payload }) {
    switch(type){
        case GETGEOLOCATION: return {...state, latitude: payload.latitude, longitude: payload.longitude, state: payload.state, city: payload.city, country: payload.country}
        case GETCITYLOCATION: return {...state, latitude: payload.latitude, longitude: payload.longitude, state: payload.state, city: payload.city, country: payload.country }
        default: return state
    }

}

// ACTIONS


export const GeoLocationAction = ({location}) => async (dispatch) => {

    

    const response = {
                        method: 'GET',
                        url: `https://first-weather-back.herokuapp.com/getlocation`,
                        params: {latitude: location.latitude, longitude: location.longitude}
    
                    } 
    
                    await axios.request(response).then((response) => {
                        
                        
                        dispatch({
                            type: GETGEOLOCATION,
                            payload: {latitude: location.latitude, longitude: location.longitude, state: response.data.results[0].components.state, city: response.data.results[0].components.city, country: response.data.results[0].components.country}
                            
                        })

                        dispatch(GetWeatherAction(location.latitude, location.longitude))
    
                    }).catch((error) => {
                        console.error(error)
                    })


                }
    

export const GeoCityLocationAction = ({cityName}) => async (dispatch) => {


    const response = {
                method: 'GET',
                url: `https://first-weather-back.herokuapp.com/getlatlon`,
                params: {city: cityName}
    
            } 
    
           await axios.request(response).then((response) => {
    
                dispatch({
                    type: GETCITYLOCATION,
                    payload: {latitude: response.data.results[0].geometry.lat, longitude: response.data.results[0].geometry.lng, state: response.data.results[0].components.state, city: response.data.results[0].components.city, country: response.data.results[0].components.country}
                })

                let latitude = response.data.results[0].geometry.lat
                let longitude = response.data.results[0].geometry.lng


                dispatch(GetWeatherAction(latitude, longitude))
                
    
            }).catch((error) => {
                console.error(error)
            })
    
        }
    

